import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { StringHelper } from "@/utils"
type WebhookParams = {
  whiteLabelId?: string
}
export const webhooks = async (params: WebhookParams) => {
  const queryString = StringHelper.objectToQueryString(params)
  const url = `${ENDPOINTS.WEBHOOKS}?${queryString}`
  const { data } = await api.get<WebhookConfigurationsResponseType>(url)
  return data
}
const useWebhooks = (params: WebhookParams) => {
  return useQuery({
    queryKey: [ENDPOINTS.WEBHOOKS, params],
    queryFn: async () => webhooks(params),
  })
}
export default useWebhooks
